import { motion, AnimatePresence } from "framer-motion";
import './appr.css';
import './mediaMobile.css';
import { useState } from 'react';

const ITEMS = [
    {
        title: "Research & Discovery",
        body: "I start by understanding the problem, the users, and the data available — mapping what success looks like before writing a line of code or a single prompt.",
    },
    {
        title: "Prototyping & Experimentation",
        body: "I build fast, testing models, prompts, and flows against real inputs — iterating quickly on what actually works instead of what looks good on paper.",
    },
    {
        title: "Human-Centered Design",
        body: "The smartest model still needs a clear, usable experience. I design intuitive interfaces around the AI so people trust it and reach for it.",
    },
    {
        title: "Ship, Measure & Iterate",
        body: "I deploy, gather real-world feedback, and refine for reliability and accuracy — treating every launch as the start of the next improvement, not the finish line.",
    },
];

export default function Approach() {
    const [open, setOpen] = useState(0);

    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } },
    };

    return (
        <section className="section apprWrapper">
            <motion.h3
                className="sec-label"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.4 }}
            >
                Approach
            </motion.h3>
            <motion.p
                className="sec-statement"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.4 }}
            >
                My approach to building intelligent products — <span className="mute">from the first question</span> to a reliable, shipped experience.
            </motion.p>

            <div className="apprAccordion">
                {ITEMS.map((item, i) => {
                    const isOpen = open === i;
                    return (
                        <div className={`apprRow ${isOpen ? 'open' : ''}`} key={item.title}>
                            <button
                                className="apprRowHead"
                                onClick={() => setOpen(isOpen ? -1 : i)}
                                aria-expanded={isOpen}
                            >
                                <span className="apprRowTitle">{item.title}</span>
                                <span className="apprChevron" aria-hidden="true">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2"
                                            strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </button>
                            <AnimatePresence initial={false}>
                                {isOpen && (
                                    <motion.div
                                        className="apprRowBody"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.35, ease: [0.25, 0.1, 0.25, 1] }}
                                    >
                                        <p>{item.body}</p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
